import orderBy from "lodash/orderBy";
const orderFacetOptions = ({ facet, items }) => facet.orderBy ? orderBy(
  items,
  facet.orderBy.map((x) => x.attribute),
  facet.orderBy.map((x) => x.direction)
) : (
  //provided default order to facet if not already configured.
  orderBy(items, ["count", "label"], ["desc", "asc"])
);
export {
  orderFacetOptions
};
//# sourceMappingURL=order-facet-options.js.map
